var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148591",
    "data-name": "Rectangle 148591",
    width: 30,
    height: 30,
    transform: "translate(-0.004)",
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save",
    transform: "translate(0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11722",
    "data-name": "Group 11722",
    transform: "translate(1.127 1.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8857",
    "data-name": "Path 8857",
    d: "M44.326,27.606a17.973,17.973,0,0,1-.915,4.456c-2.237-3.624-2.262-9.085-1.257-11.33.289-.633.56-.814.664-.822h.043a.4.4,0,0,1,.284.148c.741.729,1.425,3.4,1.171,7.54",
    transform: "translate(-31.085 -14.938)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8858",
    "data-name": "Path 8858",
    d: "M15.8,27.591a13.793,13.793,0,0,1-6.086-.5c.456-.581.929-1.216,1.382-1.882a32.285,32.285,0,0,0,2.238-3.827,4.154,4.154,0,0,0,2.111.09c3.382-.711,6.144-5.484,6.835-8.65a5.588,5.588,0,0,0-.538-4.505,3.36,3.36,0,0,0-2.176-1.457,3.7,3.7,0,0,0-2.584.536,1.31,1.31,0,1,0,1.337,2.253,1.107,1.107,0,0,1,.806-.205.714.714,0,0,1,.448.338,3.24,3.24,0,0,1,.15,2.5c-.586,2.653-2.867,6.225-4.822,6.625a1.427,1.427,0,0,1-.5.03,21.073,21.073,0,0,0,1.4-6.145c.13-2.165.208-7.431-1.945-9.546A2.965,2.965,0,0,0,11.5,2.359,3.465,3.465,0,0,0,8.661,4.7,13.919,13.919,0,0,0,7.87,11.64a15.774,15.774,0,0,0,2.706,7.581,7.3,7.3,0,0,0,.558.683,63.492,63.492,0,0,1-3.921,6.112,13.873,13.873,0,1,1,8.59,1.569",
    transform: "translate(-0.002 0.018)",
    fill: "#ff411a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconMedium);
export default __webpack_public_path__ + "static/media/logo-icon-medium.14122b5b.svg";
export { ForwardRef as ReactComponent };